/**
 * Translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCESS_NUMBER: 'Nº de acessos',
    BLACK_FRIDAY_COMISSION_TITLE: 'Comissões black friday {0}',
    BLACK_FRIDAY_COMMISSION: 'Comissões black friday {0}',
    BLACK_FRIDAY_COMMISSION_PREVIOUS: 'Comissões black friday {0}',
    COMISSION_DESCRIPTION: 'Total apurado mês corrente:',
    COMISSION_LAST_MONTH: 'Homólogo',
    COMISSION_LAST_TEN: 'Últimos {0} dias',
    COMISSION_TITLE: 'Comissões {0} dias:',
    COMMISSION: 'Comissão',
    COMMISSION_COLUMN: 'Comissão (€)',
    DAILY: 'Diário',
    DATE: 'Data',
    FEMALE: 'Feminino',
    FIFTY_DAYS: '50 Dias',
    GENDER: 'Género',
    HITS: 'Acessos {0} dias:',
    HITS_DESCRIPTION: 'Acessos',
    HOMOLOGOUS: 'Homólogo',
    HOMOLOGOUS_LAST_YEAR: 'Ano anterior',
    MALE: 'Masculino',
    NAME: 'Nome',
    NEW_CUSTOMERS: 'Novas contas cliente {0} dias:',
    NEW_CUSTOMERS_ANNIVERSARY: 'Novas contas cliente aniversário Prozis',
    NEW_CUSTOMERS_DETAIL_DESCRIPTION:
      'Novas contas pendentes de encomenda {0} dias:',
    NO_SALES: 'Sem vendas',
    ORDER_PENDING_CUSTOMERS: 'Conta pendente de encomenda',
    ORDERED_CUSTOMERS: 'Conta novo cliente',
    ORDERS: 'Encomendas {0} dias:',
    ORDERS_DESCRIPTION: 'Pagas nos últimos 6 meses',
    ORDERS_DETAIL_DESCRIPTION: 'Enc. pendentes de pagamento {0} dias:',
    ORDERS_PAY: 'Enc. pagas',
    ORDERS_PENDING: 'Enc. por pagar',
    PERCENTAGE: 'Percentagem',
    PRODUCT_CATEGORY: 'Hierarquia',
    PRODUCT_COLUMN: 'Produto',
    QT_COLUMN: 'Quantidade',
    QUANTITY: 'Quantidade',
    SALES: 'Vendas',
    SALES_DESCRIPTION: 'Mês corrente',
    SALES_PRODUCT: 'Vendas por hierarquia de produto',
    TEN_DAYS: '10 Dias',
    THIRTEEN_DAYS: '30 Dias',
    TOP_COMMISSION_TITLE: 'Top produtos mais comissionados',
    TOP_DESCRIPTION: 'Mês corrente',
    TOP_GENDER_DESCRIPTION: 'Últimos {0} dias',
    TOP_GENDER_TITLE: 'Top Vendas por género',
    TOP_TITLE: 'Top Artigos mais vendidos',
    TWENTY_DAYS: '20 Dias',
    UPDATED_AT: 'Actualizado a {0}',
    VALUE: 'Valor'
  },
  SENTENCE: {
    EMPTY_DESCRIPTION: 'Data is missing',
    EMPTY_TITLE: 'Sem resultados'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
